var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { default as Nav } from "react-bootstrap/Nav";
import { default as Navbar } from "react-bootstrap/Navbar";
import { default as Container } from "react-bootstrap/Container";
import { styleBlock } from "../styleBlock";
export default class Header extends React.PureComponent {
    render() {
        const _a = this.props, { ref, className, brand, brandHref, brandOnClick, menu, notifications, usermenu, containerWrap, containerFluid, skipLink } = _a, props = __rest(_a, ["ref", "className", "brand", "brandHref", "brandOnClick", "menu", "notifications", "usermenu", "containerWrap", "containerFluid", "skipLink"]);
        const b = styleBlock("header");
        let headerContent = (React.createElement(React.Fragment, null,
            brand && (React.createElement(Navbar.Brand, { href: brandHref ? brandHref : undefined, onClick: brandOnClick, className: b("brand").toString() + " order-first" }, brand)),
            skipLink,
            React.createElement(Navbar.Toggle, null),
            React.createElement(Navbar.Collapse, { className: "flex-grow-0 ml-auto" },
                React.createElement(Nav, null, menu)),
            React.createElement("div", { className: "notification-placeholder ml-auto ml-lg-0 order-first order-lg-0" }, notifications),
            React.createElement(Navbar.Collapse, { className: "flex-grow-0" },
                React.createElement(Nav, null, usermenu))));
        let wrapClass;
        if (containerWrap) {
            headerContent = React.createElement(Container, { fluid: containerFluid }, headerContent);
            wrapClass = containerFluid && props.expand && typeof props.expand === "string" ? `px-${props.expand}-0` : undefined;
        }
        return (React.createElement(Navbar, Object.assign({ collapseOnSelect: true, className: b({}).mix(wrapClass).mix(className).toString(), as: "header" }, props), headerContent));
    }
}
//# sourceMappingURL=index.js.map